import LBox from "@components/LBox";

const Indicator = ({ active }: { active: boolean }) => {
  return (
    <LBox
      backgroundColor={[
        "buttonBackgroundPrimaryLeft",
        "buttonBackgroundPrimaryRight",
      ]}
      borderRadius="s-m"
      gradientDirection="horizontal"
      height={2}
      opacity={active ? 1 : 0}
    />
  );
};

export default Indicator;
